import { MessageTypes } from 'web-interactives-embed-framework';
import { addRecaptchaScript, getRecaptchaNameSpace } from 'ui-forms-embed-components-library/utils/recaptcha';
import { FORMS_ENV_GLOBAL_WINDOW_NAMESPACE, QUICK_FETCH_GLOBAL_WINDOW_NAMESPACE } from 'ui-forms-embed-components-modules/constants/global';
import { modulesFindByType } from 'ui-forms-embed-components-modules/utils/module';
import reportFormEvent from 'ui-forms-embed-components-modules/internal/reportEvent';
import { RECAPTCHA_RENDER_ERROR } from 'ui-forms-embed-components-reporting/reporting/internal/constants';
export class RecaptchaContainerController {
  constructor(applicationController) {
    var _QUICK_FETCH_GLOBAL_W;
    this.renderRecaptcha = (container, parameters, inherit) => {
      const {
        sitekey,
        callback,
        size,
        badge
      } = parameters;
      this.recaptchaCallbacks['onSuccess'] = callback;
      this.recaptchaCallbacks['onExpired'] = parameters['expired-callback'];
      this.recaptchaCallbacks['onError'] = parameters['error-callback'];
      this.applicationController.sendMessage({
        type: MessageTypes.V4_RECAPTCHA_RENDER,
        payload: {
          UUID: this.UUID,
          callbackId: this.recaptchaLoadCallbackId,
          locale: this.locale,
          sitekey,
          size,
          badge,
          inherit
        }
      });
      return this.googleRecaptchaRef.render(container, parameters, inherit);
    };
    this.executeRecaptcha = () => {
      this.applicationController.sendMessage({
        type: MessageTypes.V4_RECAPTCHA_EXECUTE,
        payload: {
          UUID: this.UUID
        }
      });
    };
    this.resetRecaptcha = () => {
      this.applicationController.sendMessage({
        type: MessageTypes.V4_RECAPTCHA_RESET,
        payload: {
          UUID: this.UUID
        }
      });
    };
    this.handleRecaptchaSuccess = ({
      UUID,
      token
    }) => {
      if (this.recaptchaCallbacks.onSuccess && UUID === this.UUID) {
        this.recaptchaCallbacks.onSuccess(token);
      }
    };
    this.handleRecaptchaExpired = expiredProps => {
      if (this.recaptchaCallbacks.onExpired && expiredProps.UUID === this.UUID) {
        this.recaptchaCallbacks.onExpired();
      }
    };
    this.handleRecaptchaError = () => {
      if (this.recaptchaCallbacks.onError) {
        this.recaptchaCallbacks.onError();
      }
    };
    window._hsIsContainerRecaptchaLoaded = false;
    this.applicationController = applicationController;
    this.UUID = `${Date.now()}`;
    // Resolving initial locale from user's browser
    this.locale = navigator.language.split('-')[0] || 'en';
    this.recaptchaCallbacks = {};
    this.recaptchaLoadCallbackId = `hsV4FrameRecaptchaLoaded_${this.UUID}`.replace(/-/g, '_');
    window[this.recaptchaLoadCallbackId] = () => {
      this.googleRecaptchaRef = getRecaptchaNameSpace();
      this.proxyRecaptcha();
      this.triggerRecaptchaLoaded();
    };

    // Using quick-fetch-form to resolve locale from form settings
    (_QUICK_FETCH_GLOBAL_W = window[QUICK_FETCH_GLOBAL_WINDOW_NAMESPACE]) === null || _QUICK_FETCH_GLOBAL_W === void 0 || _QUICK_FETCH_GLOBAL_W.then(formResponse => {
      if (formResponse.error) {
        console.error('Container error loading form', formResponse.error);
        return;
      }
      const {
        renderDefinition
      } = formResponse;
      this.locale = renderDefinition.settings.locale;
      const containsRecaptcha2 = modulesFindByType(renderDefinition.form.modules, 'reCaptcha2');
      if (containsRecaptcha2) {
        addRecaptchaScript({
          callbackId: this.recaptchaLoadCallbackId,
          locale: this.locale
        });
      }
    }).catch(error => {
      const {
        formId,
        portalId,
        isQa,
        hublet
      } = window[FORMS_ENV_GLOBAL_WINDOW_NAMESPACE] || {};
      reportFormEvent({
        key: RECAPTCHA_RENDER_ERROR,
        formId,
        portalId,
        isQa,
        hublet,
        error: error instanceof Error ? error : new Error(String(error)),
        module: 'ui-forms-embed-components-frame-container'
      });
      console.error('Container error loading form', error);
    });
    this.listenForRecaptchaEvents();
  }
  proxyRecaptcha() {
    Object.defineProperty(window, 'grecaptcha', {
      value: {
        configurable: true,
        writable: true,
        enterprise: {
          render: this.renderRecaptcha,
          execute: this.executeRecaptcha,
          reset: widgetId => {
            var _this$googleRecaptcha;
            (_this$googleRecaptcha = this.googleRecaptchaRef) === null || _this$googleRecaptcha === void 0 || _this$googleRecaptcha.reset(widgetId);
            this.resetRecaptcha();
          }
        }
      }
    });
  }
  triggerRecaptchaLoaded() {
    const callbackIds = Object.getOwnPropertyNames(window).filter(propName => propName.startsWith('hsRecaptchaLoaded_'));
    for (const callbackId of callbackIds) {
      const maybeCallback = window[callbackId];
      if (typeof maybeCallback === 'function') {
        maybeCallback();
      }
    }
    window._hsIsContainerRecaptchaLoaded = true;
  }
  listenForRecaptchaEvents() {
    this.applicationController.registerHandler(MessageTypes.V4_RECAPTCHA_SUCCESS, this.handleRecaptchaSuccess);
    this.applicationController.registerHandler(MessageTypes.V4_RECAPTCHA_EXPIRED, this.handleRecaptchaExpired);
    this.applicationController.registerHandler(MessageTypes.V4_RECAPTCHA_ERROR, this.handleRecaptchaError);
  }
}
export const createRecaptchaContainerController = applicationController => new RecaptchaContainerController(applicationController);